module.exports = __webpack_public_path__ + "static/media/wood.27417d17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood.jpg
// module id = 670
// module chunks = 0